module.exports = __webpack_public_path__ + "static/img/portfolio_bg1.a2f32c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_bg-portfolio/portfolio_bg1.png
// module id = 66gW
// module chunks = 1